import { Outlet } from '@remix-run/react';
import { CheckIcon } from 'lucide-react';
import { Container } from '~/components/container';
import { HStack, VStack } from '~/components/stack';
import { PRICING_FEATURES } from '~/routes/_index/landing-pricing';
import { cn } from '~/utils/cn';

function AuthLayout() {
  return (
    <div className="bg-background min-h-[100vh] w-full flex">
      <div className="flex-1 hidden lg:flex items-center justify-center">
        <VStack className="gap-4">
          <VStack className="gap-3">
            <h2 className="text-3xl font-bold">Try for free</h2>
            <span className="font-semibold">Get access to:</span>
          </VStack>
          <VStack className="gap-3 flex-1">
            {PRICING_FEATURES.map((item) => (
              <HStack key={item} className="items-center gap-2">
                <CheckIcon size={16} />
                <span>{item}</span>
              </HStack>
            ))}
          </VStack>
        </VStack>
      </div>
      <Container
        className={cn(
          'flex-1 flex flex-col text-white py-4',
          'md:bg-navbar',
          'lg:py-0',
        )}
      >
        <div className="flex-1 flex items-start md:items-center">
          <div className="max-w-[560px] w-full mx-auto">
            <Outlet />
          </div>
        </div>
      </Container>
    </div>
  );
}

export const shouldRevalidate = () => false;

export default AuthLayout;
